import {
  Grid,
  Typography,
  useTheme
} from '@material-ui/core'
import { Snackbar } from 'elentari'
import React from 'react'
import { CriarIntegracaoEagle } from './CriarIntegracaoEagle'
import { EagleEmAnalise } from './EagleEmAnalise'
import { EagleError } from './EagleError'
import { EagleFinished } from './EagleFinished'
import { eagleStatusEnum } from './eagleStatusEnum'
import { useEagle } from './useEagle'

const EagleMapper = ({
  eagle,
  handleRefresh, 
  handleRecreate,
  handleRefreshFromDb,
  handleRecreateNewQuery,
  creating,
  initialLoading
}) => {
  const theme = useTheme()
  
  if (eagle?.status === eagleStatusEnum.FINISHED) {
    return (
      <EagleFinished 
        eagle={eagle} 
        handleRecreateNewQuery={handleRecreateNewQuery} 
        creating={creating}
        initialLoading={initialLoading}
      />
    )
  }

  if (eagle?.status === eagleStatusEnum.SENDING) {
    return (
      <EagleEmAnalise
        status="Enviando"
        handleRefresh={handleRefreshFromDb}
        backgroundColor={theme.palette.info.main}
        intervalTime={5000}
      />
    )
  }

  if (eagle?.status === eagleStatusEnum.WAITING) {
    return (
      <EagleEmAnalise
        status="Em Análise"
        handleRefresh={handleRefresh}
        backgroundColor={theme.palette.warning.main}
        intervalTime={5000}
      />
    )
  }

  if (eagle?.status === eagleStatusEnum.ERROR) {
    return (
      <EagleError
        status="Erro"
        errorMessage={eagle.messageError}
        handleRecreate={handleRecreate}
      />
    )
  }

  return (
    <EagleError
      status={eagle?.status || eagle?.error?.message || 'Erro desconhecido'}
      handleRecreate={handleRecreate}
    />
  )
}

const IntegracaoEagle = ({ solicitacaoId }) => {
  const {
    eagle,
    creating,
    handleCreate,
    handleRecreate,
    handleRefreshFromDb,
    handleRefresh,
    handleRecreateNewQuery,
    initialLoading,
    clearMessage,
    message
  } = useEagle(solicitacaoId)

  return (
    <>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <Typography variant="h6">Eagle </Typography>
        </Grid>
        <Grid item>
          {eagle && (
            <EagleMapper
              eagle={eagle}
              handleRecreate={handleRecreate}
              handleRecreateNewQuery={handleRecreateNewQuery}
              handleRefreshFromDb={handleRefreshFromDb}
              handleRefresh={handleRefresh}
              creating={creating}
              initialLoading={initialLoading}
            />
          )}
          <CriarIntegracaoEagle 
            hidden={eagle}
            creating={creating}
            handleCreate={handleCreate}
            initialLoading={initialLoading}
            tooltipText="Iniciar integração com a Eagle"
          />
        </Grid>
      </Grid>
      <Snackbar
        onClose={clearMessage}
        autoHideDuration={2000}
        message={message}
      />
    </>
  )
}

export default IntegracaoEagle
